import React from "react";
import { Typography, Container, TextField } from "@material-ui/core";

export default props => (
    <Container maxWidth="md" style={{ padding: "50px 75px" }}>
        <Typography variant="h3" component="h3" gutterBottom>
            Klientens samtykke
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
            <br />
            Med denne underskrift bekræfter jeg, at jeg er informeret om, og at jeg accepterer, at denne klinik
            registrerer, opbevarer og behandler data i forbindelse med min behandling.
            <br /> <br />
            Denne accept er afgivet inden behandlingen er påbegyndt.
            <br /> <br /> <br />
            Jeg er oplyst om <br />
            hvilke informationer, der registreres,
            <br />
            hvem, der behandler mine personoplysninger,
            <br />
            hvor lang tid disse bliver opbevaret,
            <br />
            at jeg har ret til at få mine oplysninger rettet, slettet eller udleveret, og
            <br />
            at om hvor jeg skal henvende mig, hvis jeg ønsker mine oplysninger rettet,
            <br />
            slettet eller udleveret,
            <br />
            at jeg har ret til at trække mit samtykke tilbage, og
            <br />
            hvordan jeg kan gøre det.
            <br />
            <br /> <br />
            Denne underskrift er afgivet helt frivilligt og uden tvang.
            <br /> <br />
            Yderligere giver jeg tilladelse til at klinikken må tilsende mig en sms-påmindelse dagen før aftalt
            behandling, nyhedsbreve og opfølgende mail efter en behandling.
            <br /> <br />
        </Typography>
        <TextField
            id="date-samtykke"
            label="Dato"
            multiline
            rows="4"
            defaultValue="   "
            variant="outlined"
            style={{ width: "20%" }}
        />
        <TextField
            id="signature-samtykke"
            label="Klientens underskrift"
            multiline
            rows="4"
            defaultValue="   "
            variant="outlined"
            style={{ width: "80%" }}
        />
    </Container>
);
